const defaults = {
    addCSS: true, // Add CSS to the element to improve usability (required here or in your CSS!)
    thumbWidth: 15, // The width of the thumb handle
    watch: true, // Watch for new elements that match a string target
};

export default defaults;